import {useContext, useEffect} from 'react'
import {SalesCodeContext, SELECT_SALES_CODE} from '../context/context'
import InputText from '../../../common/InputText'
import InlineCheckbox from '../../../common/InlineCheckbox'
import Button from '../../../common/Button'
import {putRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {Col, Flex, Form, Modal, Row} from 'antd'
import {useIntl} from 'react-intl'

const SalesCodeFormModal = (props) => {
  const intl = useIntl()

  const [state, dispatch] = useContext(SalesCodeContext)
  const [, navDispatch] = useContext(NavContext)

  const [form] = Form.useForm()

  const closeFormPopup = () => {
    dispatch({
      type: SELECT_SALES_CODE,
      data: { selected_sales_code: {}, show_sales_code_popup: false },
    })
    form.resetFields()
  }

  const saveSalesCode = async (values) => {
    const selected = state?.selected_sales_code || {}
    const payload = {
      ...values,
      id: selected.id,
      name: selected.name,
      group: {
        name: values.group_name,
        description: values.group_description,
      },
    }

    let res = await putRequest(
      `/api/sales_codes/save_sales_codes/${selected.id}/`,
      payload
    )

    if (res?.status !== false) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({ id: 'salesCodes.updateSuccess' }),
        },
      })
      props.getSalesCodeListData()
      closeFormPopup()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'salesCodes.saveError' }),
        },
      })
    }
  }

  // Initialize form when modal opens
  useEffect(() => {
    if (!state.show_sales_code_popup) return
    const mod = state?.selected_sales_code || {}
    form.setFieldsValue({
      name: mod.name || null,
      description: mod.description || null,
      group_name: mod.group?.name || null,
      group_description: mod.group?.description || null,
      default: mod.default || false,
    })
  }, [state.show_sales_code_popup])

  return (
    <Modal
      open={state.show_sales_code_popup}
      title={intl.formatMessage({ id: 'salesCodes.salesCodeDetails' })}
      width="50%"
      className="sales-code-form-modal"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="sales-code-form"
          name="sales-code-form"
          form={form}
          layout="vertical"
          onFinish={saveSalesCode}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <InputText
                name="name"
                label={intl.formatMessage({ id: 'salesCodes.name' })}
                isRequired={false}
                disabled
              />
            </Col>

            <Col span={12}>
              <InputText
                name="description"
                label={intl.formatMessage({ id: 'salesCodes.description' })}
                isRequired={false}
              />
            </Col>

            <Col span={12}>
              <InputText
                name="group_name"
                label={intl.formatMessage({ id: 'salesCodes.group' })}
                isRequired={false}
                disabled
              />
            </Col>

            <Col span={12}>
              <InputText
                name="group_description"
                label={intl.formatMessage({ id: 'salesCodes.groupDescription' })}
                isRequired={false}
              />
            </Col>

            <Col span={12}>
              <InlineCheckbox
                name="default"
                label={intl.formatMessage({ id: 'salesCodes.default' })}
              />
            </Col>

            <Col span={24}>
              <Flex justify="end">
                <Button htmlType="submit" type="primary">
                  {intl.formatMessage({ id: 'salesCodes.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default SalesCodeFormModal
